// extracted by mini-css-extract-plugin
export default {"imgWrapper":"ImgWrapper_imgWrapper__Tb7BA","img":"ImgWrapper_img__oF-1+"};